<template>
  <div class="col-sm-6">
    <h3 class="heading_h4 mb_16">
      What should the email say?
    </h3>
    <div class="card">
      <div class="card-body">
        <custom-input
          v-model="
            /* eslint-disable-next-line vue/no-mutating-props  TODO:*/
            from.email"
          :disabled="true"
          label="From"
          placeholder="subject"
        />

        <custom-input
          v-model="
            /* eslint-disable-next-line vue/no-mutating-props  TODO:*/
            content.subject
          "
          label="Subject"
          placeholder="subject"
        />

        <div class="content-block">
          <custom-textarea
            :id="Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)"
            v-model="
              /* eslint-disable-next-line vue/no-mutating-props  TODO:*/
              content.body
            "
            :btns="[
              ['strong', 'em', 'del'],
              ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
              ['unorderedList', 'orderedList'],
              ['horizontalRule'],
              ['link'],
              ['foreColor', 'fontsize'],
              ['removeformat'],
              ['fullscreen']
            ]"
            font="Verdana, Geneva, sans-serif"
            label=""
            style="max-width:80%"
          />

          <mail-variables
            :active-components="activeComponents"
            :email-components="emailComponents"
            :template-variables="template.variables"
          />
        </div>
      </div>
    </div>

    <p class="text-center">
      <button
        class="btn btn-success font-weight-bold xs-mt-30"
        type="button"
        @click="submit()"
      >
        Update Content
      </button>
    </p>
  </div>
</template>

<script>
import CustomTextarea from '../../../reports/components/global/forms/CustomTextarea.vue';
import CustomInput from '../../../reports/components/global/forms/CustomInput.vue';

import MailVariables from './MailVariables.vue';

export default {
  components: {
    CustomTextarea,
    CustomInput,
    MailVariables,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    content: {
      type: Object,
      default: null,
    },
    from: {
      type: Object,
      default: null,
    },
    emailComponents: {
      type: Object,
      default: null,
    },
    activeComponents: {
      type: Array,
      default: null,
    }
  },
  emits: ['submitForm'],
  methods: {
    submit() {
      this.$emit('submitForm');
    }
  }
}
</script>

<style scoped>
.placeholders {
  width: 25%;
  margin-top: 10px;
}

.placeholders > .title {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
  margin-bottom: 0.25rem;
  padding: 7px 10px;
  border-radius: 3px;
  font-weight: 700;
}

/* accordion */
.accordion_body {
  transition: 300ms;
}

.page_accordion .accordion_wrapper.active .accordion_head {
  background-color: #37B2A8;
}

.accordion_head > button {
  margin-left: 1rem
}

.accordion_head .move-page {
  display: none;
}

.accordion_head .delete {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.8745 4.375L3.12451 4.37501' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8.125 8.125V13.125' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11.875 8.125V13.125' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M15.6245 4.375V16.25C15.6245 16.4158 15.5587 16.5747 15.4415 16.6919C15.3242 16.8092 15.1653 16.875 14.9995 16.875H4.99951C4.83375 16.875 4.67478 16.8092 4.55757 16.6919C4.44036 16.5747 4.37451 16.4158 4.37451 16.25V4.375' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  width: 1.25rem;
  height: 1.25rem;
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  display: none;
}

.accordion_wrapper.active .accordion_head .delete,
.accordion_wrapper.active .accordion_head .move-page {
  display: block;
}

.accordion_head, .accordion_sub_head {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  gap: .5rem;
}

.content-block {
  display: flex;
  gap: 1rem;
}

.heading_h4 {
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
  font-weight: 700;
}

@media screen and (max-width: 1200px) {
  .heading_h4 {
    font-size: 1.25rem;
  }
}
</style>
